import { render, staticRenderFns } from "./HazirEvrakGonderIslemDetayView.vue?vue&type=template&id=0c54cad1&scoped=true"
import script from "./HazirEvrakGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./HazirEvrakGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c54cad1",
  null
  
)

export default component.exports